module.exports = __webpack_public_path__ + "img/pipe.500c8440.png";